import React, { Component } from "react";
import { Modal, Form, Input, FormInstance } from "antd";

interface FormProps {
    visible: boolean,
    failData: string,
    confirmLoading: boolean,
    onCreate: (values: any) => void,
    onCancel: () => void,
}

class NewAdmin extends Component<FormProps> {
    
    formRelf;
    constructor (props) {
        super(props);
        this.formRelf = React.createRef<FormInstance>();
    }

    render () {

        const { 
            visible, onCancel, onCreate, 
            failData, confirmLoading, 
        } = this.props;
        const layout = {
            labelCol: { span: 5 },
            wrapperCol: { span: 19 },
        };

        return (
            <Modal
                maskClosable={false}
                destroyOnClose={true}
                open={visible}
                confirmLoading={confirmLoading}
                title='添加管理员'
                okText='确定'
                cancelText='取消'
                onCancel={onCancel}
                onOk={
                    () => {
                        this.formRelf.current!.validateFields().then(values => {
                            onCreate(values);
                        }).catch(info => {
                            console.log('Valide Failed:', info);
                        })
                    }
                }
            >
                <Form
                    {...layout}
                    ref={this.formRelf}
                    layout='horizontal'
                    name='form'
                    >
                    <Form.Item label='姓名' name="name">
                        <Input />
                    </Form.Item>
                    <Form.Item label="账号" name="mobileNumber" rules={[{required: true}]} >
                        {/* <Input placeholder="请输入已注册的员工手机号"/> */}
                        <Input placeholder="请输入员工手机号"/>
                    </Form.Item>
                </Form>
                <p className="error-center">{failData}</p>
            </Modal>
        )
    }
}

export default NewAdmin